<template>
  <div class="bug_dialog_container">
    <div class="buy_dialog">
      <img
        :src="banner"
        alt="背景图" class="vip_activity_top_img">
      <div class="buy_dialog_left">
        <UserInfo />
        <Privilege v-if="packageActive" :name="packageActive.name" />
      </div>
      <div class="buy_dialog_right">
        <div v-if="dialogType === payDialogType.activity" class="flex-space">
          <div>
            <Countdown />
            <PriceBox
              v-if="packageActive"
              class="mg_top_9"
              :name="packageActive.name" :price="packageActive.priceOriginal"
              :discountPrice="packageActive.priceReal" :tipMiddle="packageActive.tipMiddle"
              :tipsFooter="packageActive.tipsFooter" :isSelected="true"
            />
          </div>
          <div class="more" @click="clickMore">
            <span class="text">更多套餐</span>
            <i class="arrow_right" />
          </div>
        </div>
        <div v-else class="flex-space">
          <PriceBox
            v-for="(item, index) in packageList" :key="index"
            :name="item.name" :price="item.priceOriginal"
            :discountPrice="item.priceReal" :tipMiddle="item.tipMiddle"
            :tipsFooter="item.tipsFooter" size="size_small" :isSelected="packageIndexActive === index"
            :isShowCountDown="getIsShowCountDown(index, true)"
            class="pointer" @click.native="clickPriceBox(index)"
          />
        </div>
        <DiscountLine
          v-if="packageActive" :detail="discountLineDetail(packageActive)" :canOpen="false"
          class="mg_top_13" />
        <DiscountLine
          v-if="packageIndexActive === 0"
          :detail="discountLineCouponDetail" :detailListOpened="discountLineCouponOpened"
          class="mg_top_8" />
        <PayBox
          v-if="packageActive"
          :class="['mg_top_12']" :style="{ height: heightPayBox }"
          :dialogType="dialogType" :price="packageActive.priceReal" :pageid="pageid"
          :priceMinus="packageActive.priceMinus" :packageId="packageActive.id"
          :payResultExt="payResultExt"
          @reload="loadPackages" @close="close" />
        <IconClose class="close" @click.native="clickClose" />
      </div>
    </div>
    <PayStay
      v-if="showPayStay"
      :type="dialogStayType.pay"
      @clickNoUse="clickNoUseStay"
      @clickUse="closePayStayBox"
    />
  </div>
</template>

<script>
import UserInfo from './UserInfo'
import Privilege from './Privilege'
import PriceBox from './PriceBox'
import DiscountLine from './DiscountLine'
import PayBox from './PayBox/index'
import Countdown from './Countdown'
import PayStay from '@/components/UserStay/index.vue'

import api from '@/api'
import { ClientCloseSelf } from '@/api/clientApi.js'
import { payDialogType, dialogStayType } from '@/common/const.js'
import IconClose from '@/components/Icons/IconClose.vue'
import { report } from '@/report'

const chan = 'mid_autumn_activity'

export default {
  name: 'BuyDialogNew',

  components: { UserInfo, Privilege, PriceBox, DiscountLine, PayBox, IconClose, Countdown, PayStay },

  data () {
    return {
      packageList: [],
      payDialogType,
      dialogStayType,
      packageIndexActive: 0,
      banner: '',
      dialogType: payDialogType.activity,
      showPayStay: false,
      redPackageMinus: 0
    }
  },

  computed: {
    isDuBaVip () {
      return this.$store.state.isDubaVip
    },
    discountLineCouponOpened () {
      return [
        {
          title: this.redpackageTitle,
          text: `-￥${this.redPackageMinus}`
        }
      ]
    },
    discountLineCouponDetail () {
      return {
        title: this.redpackageTitle,
        text: `-￥${this.redPackageMinus}`,
        validate: '即将失效'
      }
    },
    redpackageTitle () {
      let title = '金秋限时红包：'
      if (this.isDuBaVip) {
        title = '毒霸会员专属红包：'
      }
      return title
    },
    packageActive () {
      return this.packageList[this.packageIndexActive]
    },
    isPackageForever () {
      return this.packageIndexActive === 0
    },
    heightPayBox () {
      if (this.dialogType === payDialogType.pay && this.isPackageForever) {
        return '169px'
      } else if (this.dialogType === payDialogType.pay) {
        return '209px'
      }
      return ''
    },
    pageid () {
      return this.dialogType === payDialogType.pay ? 1 : 2
    }
  },

  mounted () {
    this.reportDialogShow()
    this.initRedPackageMinus()
    this.loadPackages()
    this.getBanner()
  },

  methods: {
    /** 点击-关闭弹窗 **/
    clickClose () {
      this.reportClickClose()
      this.showPayStayBox()
    },

    /** 点击-切换套餐 **/
    clickPriceBox (index) {
      this.packageIndexActive = index
    },

    clickMore () {
      /** 上报-切换更多套餐 **/
      report('pay', { actiontype: 'payclick', actionid: 1, pageid: this.pageid, ext: '' })
      this.dialogType = payDialogType.pay
      this.reportDialogShow()
    },

    clickNoUseStay () {
      /** 上报-挽留窗点击我不需要 **/
      report('pay', { actiontype: 'stayclick', actionid: 2, pageid: this.pageid, ext: '' })
      this.close()
    },

    initRedPackageMinus () {
      if (this.isDuBaVip) {
        this.redPackageMinus = 100
      } else {
        this.redPackageMinus = 40
      }
    },

    showPayStayBox () {
      report('pay', { actiontype: 'stayshow', actionid: '', pageid: this.pageid, ext: '' })
      this.showPayStay = true
    },

    getIsShowCountDown (index, isSmall) {
      return index === 0 && isSmall
    },

    closePayStayBox () {
      /** 上报-挽留窗点击立即使用 **/
      report('pay', { actiontype: 'stayclick', actionid: 1, pageid: this.pageid, ext: '' })
      this.showPayStay = false
    },

    getBanner () {
      api.common.config({ data: { conf_code: this.confBanner } }).then(res => {
        const config = res?.data?.data?.content
        if (config) {
          this.banner = config
        }
      })
    },

    close () {
      ClientCloseSelf()
    },

    reportClickClose () {
      report('pay', { actiontype: 'payclick', actionid: 0, pageid: this.pageid, ext: '' })
    },

    /** 上报-支付窗展示 **/
    reportDialogShow () {
      report('pay', { actiontype: 'payshow', actionid: '', pageid: this.pageid, ext: '' })
    },

    loadPackages () {
      this.getPackages(chan).then(packages => {
        // 特殊处理-过滤套餐：后端约定，数组第一位为毒霸会员-终身会员套餐，第二位为非毒霸会员-终身会员套餐
        if (this.isDuBaVip) {
          packages.splice(1, 1)
        } else {
          packages.splice(0, 1)
        }

        const packagesClean = packages.map(item => this.clean(item))
        this.packageList = packagesClean
      })
    },

    clean (packageItem) {
      const item = {
        id: packageItem.id,
        name: packageItem.name,
        priceOriginal: this.toPriceYuan(packageItem.price),
        priceDiscount: this.toPriceYuan(packageItem.discount_price), // 折扣减去的价格
        priceReal: this.toPriceYuan(packageItem.real_price),
        tipMiddle: packageItem.detail,
        tipsFooter: packageItem.tips.split(',')
      }
      return this.setNewData(item)
    },

    setNewData (origin) {
      // 设置新数据
      const dataNew = {
        priceAfterDiscount: this.calcPriceAfterDiscount(origin),
      }
      if (origin.name === '终身VIP') {
        dataNew.priceMinus = (this.redPackageMinus + origin.priceDiscount).toFixed(2)
      } else {
        dataNew.priceMinus = origin.priceDiscount.toFixed(2)
      }

      // 复制
      const o = Object.assign({}, origin, dataNew)

      // 折率记录需要dataNew和origin数据，单独计算
      o.priceDiscountPercentage = this.calcPriceDiscountPercentage(o)

      return o
    },

    calcPriceAfterDiscount (item) {
      let s = (item.priceOriginal - item.priceDiscount).toFixed(1)
      if (s.endsWith('.0')) {
        s = s.slice(0, -2)
      }
      return s
    },

    calcPriceDiscountPercentage (item) {
      const percentage = item.priceAfterDiscount / item.priceOriginal * 10
      // 保留1位小数，四舍五入
      return Math.round(percentage * 10) / 10
    },

    // 处理为单位元
    toPriceYuan (priceMinute) {
      return priceMinute / 100
    },

    getPackages (chan) {
      return api.member.packages({ data: { chan } }).then(item => item.data.pri_packages)
    },

    getServiceTime () {
      return api.common.getServiceTime().then(res => res?.data?.timestamp * 1000)
    },

    discountLineDetail (packageClean) {
      return {
        title: '折扣优惠：',
        text: `-￥${packageClean.priceDiscount}（${packageClean.priceDiscountPercentage}折）`,
        validate: packageClean.priceDiscountExpire
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.bug_dialog_container { width: 782x; height: 545px; background: url(~@/assets/images/bg_mid_autumn_pay_dialog.png);
  .buy_dialog { position: absolute; box-sizing: border-box; display: flex; justify-content: space-between; width: 766px; height: 454px; padding: 24px 16px; margin: 84px 8px 8px 8px; background: #F5F6FA; border-radius: 8px;
    .buy_dialog_left { display: flex; flex-direction: column; justify-content: space-between; height: 100%; }
    .buy_dialog_right { display: flex; flex-direction: column; justify-content: space-between; width: 536px; height: 100%; }
  }
  .pointer { cursor: pointer; }
  .flex-space { display: flex; justify-content: space-between; width: 100%; }
  .noHasCoupon { margin-top: 17px; }
  .close { position: absolute; top: 7px; right: 7px; }
  .vip_activity_top_img { position: absolute; top: -108px; left: -8px; z-index: -1; }
  .more { display: flex; align-items: center; width: 62px; height: 182px; margin-left: 17px; cursor: pointer; background: #FFFBE9; border: 1px solid #FFD691; border-radius: 4px;
    .text { width: 24px; margin-left: 15px; font-size: 12px; }
    .arrow_right { width: 9px; height: 9px; margin-left: 6px; border-top: 1px solid black; border-right: 1px solid black; writing-mode: tb-rl; -ms-transform: translateY(-3px) rotate(45deg); transform: translateY(-3px) rotate(45deg); }
  }
  .mg_top_9 { margin-top: 9px; }
  .mg_top_12 { margin-top: 12px; }
  .mg_top_13 { margin-top: 13px; }
  .mg_top_8 { margin-top: 8px; }
}

</style>
